<template>
	<aside
		data-e2e="ed-urr"
		class="module module-unified-right-rail module-ed-urr"
		id="ed-urr"
		data-metrics-module="ed-urr"
		:role="isSiteFronts ? 'complementary' : ''"
	>
		<header>			
			<div class="header-container">
				<h3>{{ title }}</h3>
			</div>
			<img
				v-if="getImage && getImage.path"
				:src="getImage.src"
				:alt="getImage.alt"
			>
		</header>
		<WebmdRow
			class="unified_right_inner_v2_rdr"
		>
			<div
				class="tow_list"
				v-if="items.length > 0"
			>
				<template
					v-for="(item, index) in items"
					:key="createKey(index)"
				>
					<div
						:class="item.class"
					>
						<a
							v-metric:track="{
								module: 'ed-urr',
								link: item.metricsLink
							}"
							:href="item.link"
						>
							<h4 class="tow-no-image-h4">
								{{ item.title }}
							</h4>
							<p>
								{{ item.paragraph }}
							</p>
						</a>
					</div>
				</template>
				<SetRendered
					:chronic-id="chronicId"
					:data="{'items': items, 'moduleData': getModuleByChronicId}"
				/>
			</div>
		</WebmdRow>
	</aside>
</template>

<script>
import useStore from 'webmd-cms-store/src/store';


import { Row } from 'webmd-elements';
import _has from 'lodash/has';
import _isArray from 'lodash/isArray';
import SetRendered from './SetRendered.vue';
import _pick from 'lodash/pick';
import { nextTick } from 'vue';
import _sample from 'lodash/sample';

export default {
	components: {
		SetRendered,
		WebmdRow: Row
	},
	props: {
		chronicId: {
			type: String,
			required: true,
		},
		isDev: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			items: [],
			moduleByChronicId: [],
			title: 'Today on WebMD',
			renderAd: false,
			isMobile: true,
			imagesData: [],
		};
	},
	computed: {
		getItems() {
			const self = this;
			const module = this.getModuleByChronicId;
			let pos = 9001;
			const items = _has(module, 'module_data.links.link') && _isArray(module.module_data.links.link) ? module.module_data.links.link.map((link) => (
				{
					title: link.action_text ? link.action_text : '',
					paragraph: link.link_text ? link.link_text : '',
					// eslint-disable-next-line no-nested-ternary
					link: _has(link, 'link_url.link_friendlyUrl') ? link.link_url.link_friendlyUrl : '',
					class: 'entry_fmt',
					// eslint-disable-next-line	no-plusplus
					pos: pos++,
					metricsLink: `${pos - 9001}${self.getMetricsLink(link.link_text || '')}`,
				}
			)) : [];

			// eslint-disable-next-line
			return items;
		},
		isInfinite() {
			return this.store.flow.isInfinite;
		},
		getTitle() {
			const moduleData = this.getModuleByChronicId;
			let title = null;

			if (_has(moduleData, 'module_data.module_title.title')) {
				// eslint-disable-next-line prefer-destructuring
				title = moduleData.module_data.module_title.title;
			} else if (_has(moduleData, 'module_data.module_title')) {
				// eslint-disable-next-line prefer-destructuring
				title = moduleData.module_data.module_title;
			}

			if (!title) {
				// eslint-disable-next-line prefer-destructuring
				title = this.title;
			}

			return title;
		},

		getImage() {
			const imageServerPath = this.store?.pagedata?.omniture?.image_server_url;
			const moduleData = this.getModuleByChronicId;

			let images = moduleData.module_data.body_images.body_image.map(m => {
				return {
					src: `${imageServerPath}${m.source.path}?resize=300px:*&output-quality=75`,
					alt: m.source.alt,
					path:m.source.path
				}
			})

			return _sample(images);
		},

		getModuleByChronicId() {
			const module = this.store.cms.getModules(this.chronicId);
			return module;
		},
		isSiteFronts() {
			const sfData = this.store.cms.siteFronts;
			if (_has(sfData, 'mode')) {
				return sfData.mode.toLowerCase() === 'sitefronts';
			}
			return false;
		},
	},
	methods: {
		getImagePath(link) {
			const defaultImgPath = 'webmd/consumer_assets/site_images/article_thumbnails/other/symptom_checker_man_woman_other/493x335_symptom_checker_man_woman_other.jpg';
			const resizeVal = '?resize=110px:*&amp;output-quality=50';
			const imageServerPath = this.store?.pagedata?.omniture?.image_server_url;
			let path = '';

			path = _has(link, 'link_source_icon.path') ? link.link_source_icon.path : defaultImgPath;

			return imageServerPath + path + resizeVal;
		},

		getMetricsLink(s = '') {
			switch (s.toLowerCase()) {
				case 'video':
					return 'vid';
				case 'feature':
					return 'ftr';
				case 'slideshow':
				case 'slide show':
					return 'ss';
				case 'quiz':
					return 'rmq';
				default:
					return 'othr';
			}
		},
		entryMetricsLink(i) {
			return (i > 0 ? i + 9000 : i + 9001);
		},
		createKey(i) {
			return `key-id-${i}`;
		},
	},
	created() {
		this.store = useStore(this.$pinia);
		this.items = this.getItems;
		this.title = this.getTitle;
	}
};
</script>

<style lang="scss" src="./stylesheets/component.scss">
</style>
